export default "__VITE_ASSET__BmQYUEpI__"